import { throttle } from 'lodash';
import template from './template';
import selectors from './constants/selectors';
import prepareFadeIn from '../../utils/fade-in';
import removeElementById from '../../utils/remove-element-by-id';
import parseElementFromString from '../../utils/parse-element-from-string';
import hasPageStaticHeader from '../../utils/has-page-static-header';

function initialize() {
  function replaceSvg() {
    const newSvg = document.getElementById('new-svg');

    if (newSvg) return;

    setTimeout(() => {
      const breakpoint = window.matchMedia('(min-width: 1200px)');

      let oldLanguageFlag;

      if (hasPageStaticHeader()) {
        oldLanguageFlag = document.querySelector(selectors.STATIC_HEADER_LANGUAGE_SELECTOR_ICON);
      } else if (breakpoint.matches) {
        oldLanguageFlag = document.querySelector(selectors.GLOBAL_HEADER_LANGUAGE_SELECTOR_ICON);
      }

      if (!oldLanguageFlag) return;

      const newLanguageFlagSVG = template();
      const newLanguageFlag = parseElementFromString(newLanguageFlagSVG);

      oldLanguageFlag.replaceWith(newLanguageFlag);
    }, 10);
  }

  replaceSvg();

  window.addEventListener('resize', throttle(replaceSvg, 100), false);

  const languageSelector = document.querySelector(selectors.LANGUAGE_SELECTOR);
  const fadeIdAnimation = prepareFadeIn(languageSelector);

  removeElementById('cms-i-language-selector');
  fadeIdAnimation.run();
}

export default initialize;
